import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ScribbleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M4.59003 6.89C5.29003 6.18 5.99003 5.54 6.30003 5.67C6.80003 5.87 6.30003 6.7 6.00003 7.19C5.75003 7.61 3.14003 11.08 3.14003 13.5C3.14003 14.78 3.62003 15.84 4.48003 16.48C5.23003 17.04 6.22003 17.21 7.12003 16.94C8.19003 16.63 9.07003 15.54 10.18 14.17C11.39 12.68 13.01 10.73 14.26 10.73C15.89 10.73 15.91 11.74 16.02 12.52C12.24 13.16 10.64 16.19 10.64 17.89C10.64 19.59 12.08 20.98 13.85 20.98C15.48 20.98 18.14 19.65 18.54 14.88H21V12.38H18.53C18.38 10.73 17.44 8.18 14.5 8.18C12.25 8.18 10.32 10.09 9.56003 11.02C8.98003 11.75 7.50003 13.5 7.27003 13.74C7.02003 14.04 6.59003 14.58 6.16003 14.58C5.71003 14.58 5.44003 13.75 5.80003 12.66C6.15003 11.57 7.20003 9.8 7.65003 9.14C8.43003 8 8.95003 7.22 8.95003 5.86C8.95003 3.69 7.31003 3 6.44003 3C5.12003 3 3.97003 4 3.72003 4.25C3.36003 4.61 3.06003 4.91 2.84003 5.18L4.59003 6.89ZM13.88 18.55C13.57 18.55 13.14 18.29 13.14 17.83C13.14 17.23 13.87 15.63 16.01 15.07C15.71 17.76 14.58 18.55 13.88 18.55Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
